import React from 'react';
import { MessageCircleIcon, SendIcon, MailIcon, ArrowRightIcon, ZapIcon } from 'lucide-react';
interface ButtonProps {
  type: 'whatsapp' | 'telegram' | 'email' | 'primary';
  text?: string;
  className?: string;
  onClick?: () => void;
}
export const CTAButton: React.FC<ButtonProps> = ({
  type,
  text,
  className = '',
  onClick
}) => {
  const getIcon = () => {
    switch (type) {
      case 'whatsapp':
        return <MessageCircleIcon size={18} data-id="element-68" />;
      case 'telegram':
        return <SendIcon size={18} data-id="element-69" />;
      case 'email':
        return <MailIcon size={18} data-id="element-70" />;
      case 'primary':
        return <ArrowRightIcon size={18} data-id="element-71" />;
      default:
        return null;
    }
  };
  const getDefaultText = () => {
    switch (type) {
      case 'whatsapp':
        return 'WhatsApp';
      case 'telegram':
        return 'Telegram';
      case 'email':
        return 'Email';
      case 'primary':
        return 'Learn More';
      default:
        return '';
    }
  };
  const getStyles = () => {
    switch (type) {
      case 'whatsapp':
        return 'bg-green-600 hover:bg-green-700';
      case 'telegram':
        return 'bg-blue-500 hover:bg-blue-600';
      case 'email':
        return 'bg-gray-700 hover:bg-gray-800';
      case 'primary':
        return 'bg-red-700 hover:bg-red-800';
      default:
        return 'bg-black hover:bg-gray-900';
    }
  };
  const buttonText = text || getDefaultText();
  const buttonStyles = getStyles();
  return <button onClick={onClick} className={`flex items-center justify-center px-4 py-2 text-white rounded transition-all ${buttonStyles} ${className}`} data-id="element-72">
      <span className="mr-2" data-id="element-73">{getIcon()}</span>
      <span data-id="element-74">{buttonText}</span>
    </button>;
};
export const CTAGroup: React.FC<{
  className?: string;
  showPriority?: boolean;
}> = ({
  className = '',
  showPriority = false
}) => {
  return <div className={`flex flex-wrap gap-3 ${className}`} data-id="element-75">
      <div className="relative" data-id="element-76">
        {showPriority && <div className="absolute -top-2 -right-2 bg-yellow-400 text-black text-xs font-bold px-2 py-1 rounded-full flex items-center" data-id="element-77">
            <ZapIcon className="h-3 w-3 mr-1" data-id="element-78" />
            Fastest
          </div>}
        <CTAButton type="whatsapp" onClick={() => window.open('https://wa.me/YOURPHONENUMBER', '_blank')} data-id="element-79" />
      </div>
      <CTAButton type="telegram" onClick={() => window.open('https://t.me/YOURUSERNAME', '_blank')} data-id="element-80" />
      <CTAButton type="email" onClick={() => window.location.href = 'mailto:info@debtrescue.it.com'} data-id="element-81" />
    </div>;
};